export const membersAreaEnabled = (state = false): boolean => state
